/** Ужимает dataURL до ширины w в JPEG — журнал и треды не должны раздувать storage. */
export function thumb(dataUrl: string, w: number, quality = 0.62): Promise<string> {
  return new Promise((resolve) => {
    const i = new Image()
    i.onload = () => {
      const c = document.createElement('canvas')
      const h = Math.round((w * i.height) / i.width) || w
      c.width = w
      c.height = h
      const g = c.getContext('2d')!
      g.fillStyle = '#fff'
      g.fillRect(0, 0, w, h)
      g.drawImage(i, 0, 0, w, h)
      resolve(c.toDataURL('image/jpeg', quality))
    }
    i.onerror = () => resolve(dataUrl)
    i.src = dataUrl
  })
}

export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const i = new Image()
    i.onload = () => resolve(i)
    i.onerror = reject
    i.src = src
  })
}

export function fileToDataURL(f: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader()
    r.onload = () => resolve(String(r.result))
    r.onerror = reject
    r.readAsDataURL(f)
  })
}
